/**
 * @param {{ branding: { name?: string; logo_url?: string | null } | null; subtitle?: React.ReactNode; wordmarkSrc?: string }} props
 */
export function PortalBrandHeader({ branding, subtitle, wordmarkSrc }) {
  const name = branding?.name || 'Client portal';
  const letter = String(name).trim().slice(0, 1).toUpperCase() || 'P';

  if (wordmarkSrc) {
    return (
      <div className="portal-brand-header portal-brand-header--wordmark" data-tour="tour-header-brand">
        <img src={wordmarkSrc} alt="AGENCY360" className="agency-wordmark" />
        {subtitle ? (
          <p className="muted small" style={{ margin: 0 }}>
            {subtitle}
          </p>
        ) : null}
      </div>
    );
  }

  return (
    <div className="portal-brand-header" data-tour="tour-header-brand">
      {branding?.logo_url ? (
        <img src={branding.logo_url} alt="" className="portal-brand-logo" />
      ) : (
        <span className="brand-mark" aria-hidden>
          {letter}
        </span>
      )}
      <div>
        <h1>{name}</h1>
        {subtitle ? (
          <p className="muted small" style={{ margin: 0 }}>
            {subtitle}
          </p>
        ) : null}
      </div>
    </div>
  );
}
